/* eslint global-require: off */

// Plugins
import { BrowserRouter as Router } from 'react-router-dom';
import Api from 'Helpers/api';
// import * as OfflinePluginRuntime from 'offline-plugin/runtime';

// Components
import App from './App';

/* Init Api */
Api.init();

/* SERVICE WORKER INIT */
// OfflinePluginRuntime.install({
// 	onUpdateReady: () => {
// 		Log.debug('SW Event: onUpdateReady - Apply update');
// 		// Tells to new SW to take control immediately
// 		OfflinePluginRuntime.applyUpdate();
// 	},
// 	onUpdated: () => {
// 		Log.debug('SW Event: onUpdated - Reload page');
// 		// Reload the webpage to load into the new version
// 		window.location.reload();
// 	},
// 	onUpdateFailed: () => {
// 		Log.debug('SW Event: onUpdateFailed');
// 	}
// });
/* END SERVICE WORKER */

/* INIT REACT APP */
ReactDOM.render(
	<Router>
		<App />
	</Router>,
	document.getElementById('app')
);
